import PropTypes from 'prop-types';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

import { emailRegex } from 'constants/regex';
import { componentsSize } from 'constants/components';
import ListInput from 'components/complex/ListInput';
import { EmailIcon } from 'assets/icons';

const styles = {
  container: ({ palette, breakpoints }) => ({
    borderRadius: 2.5,
    paddingBlock: 4,
    paddingInline: 2,
    backgroundColor: palette.colors.lightPale,
    marginBottom: 4,
    [breakpoints.up('sm')]: {
      borderRadius: 6,
      paddingBlock: 5,
      paddingInline: 6,
      marginBottom: 8,
    },
    [breakpoints.up('md')]: {
      borderRadius: 6,
      paddingInline: 10,
      marginBottom: 15,
    },
  }),
  titleIcon: ({ breakpoints }) => ({
    width: 24,
    height: 24,
    marginRight: 1,
    [breakpoints.up('md')]: {
      width: 32,
      height: 32,
    },
  }),
  sendButton: {
    alignSelf: 'flex-start',
  },
};

const validateEmail = (email) => emailRegex.test(email);

export const UsersInvitationBlock = ({
  dataPrefix,
  title = 'Add Users',
  subTitle = null,
  inviteDetails,
  sendButtonLabel,
  isDisabledInvite,
  onInviteSend,
  listInputProps,
  customStyles = {},
}) => (
  <Paper elevation={0} sx={[styles.container, customStyles]}>
    <Stack spacing={2.5}>
      <Stack spacing={1.5}>
        <Typography variant="h2-bold">
          <Box component={EmailIcon} sx={styles.titleIcon} />
          {title}
        </Typography>

        {subTitle}

        <ListInput {...listInputProps} validate={validateEmail} id={`${dataPrefix}-input`} />
      </Stack>

      {inviteDetails}

      <Button
        size={componentsSize.small}
        onClick={onInviteSend}
        disabled={isDisabledInvite}
        id={`${dataPrefix}-send-button`}
        sx={styles.sendButton}
      >
        {sendButtonLabel}
      </Button>
    </Stack>
  </Paper>
);

UsersInvitationBlock.propTypes = {
  dataPrefix: PropTypes.string.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.node,
  inviteDetails: PropTypes.node.isRequired,
  sendButtonLabel: PropTypes.string.isRequired,
  isDisabledInvite: PropTypes.bool.isRequired,
  onInviteSend: PropTypes.func.isRequired,
  listInputProps: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
    allowDuplicates: PropTypes.bool,
    placeholder: PropTypes.string,
    onInputChange: PropTypes.func,
  }).isRequired,
  customStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};
